import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DistributionQueueComponent } from './distribution-queue.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { QueueConfigurationComponent } from './queue-configuration/queue-configuration.component';
import { SegmentationComponent } from './queue-configuration/segmentation/segmentation.component';
import { RouterModule } from '@angular/router';
import { AddQueueComponent } from './queue-configuration/add-queue/add-queue.component';
import { CriteriaModalComponent } from './components/criteria-modal/criteria-modal.component';
import { SegmentationModalComponent } from './components/segmentation-modal/segmentation-modal.component';
import { StringListPipe } from './pipes/string-list.pipe';
import { DestinationComponent } from './queue-configuration/destination/destination.component';
import { AddFilterModalComponent } from './queue-configuration/add-filter-modal/add-filter-modal.component';
import { AddRuleDestinationComponent } from './queue-configuration/destination/add-rule-destination/add-rule-destination.component';
import { MatAutocompleteModule, MatIconModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatSnackBarModule } from '@angular/material';
import { PermissionComponent } from './queue-configuration/permission/permission.component';
import { QueueParticipantsComponent } from './queue-participants/queue-participants.component';
import { FilterRowComponent } from './queue-configuration/destination/filter-row/filter-row.component';
import { DuplicateModalComponent } from './components/duplicate-modal/duplicate-modal.component';
import { NgZorroAntdModule, NzButtonModule, NzDatePickerModule, NzModalModule, NzPaginationModule, NzSelectModule } from 'ng-zorro-antd';
import { ParticipantsComponent } from './queue-configuration/participants/participants.component';
import { LeadsManagementComponent } from './leads-management/leads-management.component';
import { BreadcrumbsDistributionComponent } from './components/breadcrumbs-distribution/breadcrumbs-distribution.component';
import { LeadsUnansweredComponent } from './leads-management/leads-unanswered/leads-unanswered.component';
import { ReconfigurationComponent } from './queue-configuration/reconfiguration/reconfiguration.component';
import { ListParticipantsMobileComponent } from './queue-participants/components/list-participants-mobile/list-participants-mobile.component';
import { SearchParticipantsComponent } from './queue-participants/components/search-participants/search-participants.component';
import { ListParticipantsComponent } from './queue-participants/components/list-participants/list-participants.component';
import { DistributionQueueHeaderComponent } from './components/distribution-queue-header/distribution-queue-header.component';

@NgModule({
  declarations: [
    DistributionQueueComponent,
    QueueConfigurationComponent,
    SegmentationComponent,
    AddQueueComponent,
    CriteriaModalComponent,
    DuplicateModalComponent,
    SegmentationModalComponent,
    StringListPipe,
    DestinationComponent,
    AddFilterModalComponent,
    AddRuleDestinationComponent,
    PermissionComponent,
    QueueParticipantsComponent,
    FilterRowComponent,
    ParticipantsComponent,
    LeadsManagementComponent,
    BreadcrumbsDistributionComponent,
    LeadsUnansweredComponent,
    ReconfigurationComponent,
    ListParticipantsComponent,
    ListParticipantsMobileComponent,
    SearchParticipantsComponent,
    DistributionQueueHeaderComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    RouterModule,
    MatRadioModule,
    NgZorroAntdModule,
    NzModalModule,
    NzPaginationModule,
    NzDatePickerModule,
    NzSelectModule,
    NzButtonModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatIconModule,    
    MatAutocompleteModule
  ],
  exports: [
    DistributionQueueComponent,
    QueueConfigurationComponent,
    AddQueueComponent,
    SegmentationComponent,
    CriteriaModalComponent,
    DuplicateModalComponent,
    SegmentationModalComponent,
    StringListPipe,
    AddFilterModalComponent,
    PermissionComponent,
    QueueParticipantsComponent,
    LeadsManagementComponent,
    BreadcrumbsDistributionComponent
  ],
  entryComponents: [
    AddFilterModalComponent,
    AddRuleDestinationComponent
  ],
  providers: [
    DatePipe
  ]
})
export class DistributionQueueModule { }
